import { FormikContextType, useFormikContext } from 'formik';
import React from 'react';
import styles from './ParalelArivals.module.scss';
import { Input } from '../../../../shared/Forms';

export const ParalelArivals: React.FC<any> = () => {
  const formik = useFormikContext();
  const { values, handleChange, handleBlur }: FormikContextType<any> = formik;
  const { locations } = values;

  return (
    <>
      <section className={styles.header}>
        <h4 className="mb-1 mr-2">Кількість паралельних завантажень</h4>
        <span>(поточне значення)</span>
      </section>
      <section className={styles.body}>
        {locations?.map((location: any, index: number) => (
          <div className={styles.element}>
            <span className={styles.text}>{location.name}</span>
            <Input
              className={styles.input}
              type="number"
              placeholder="0"
              name={`locations[${index}].numberParallelLoadings`}
              value={location.numberParallelLoadings}
              onChange={handleChange}
              onBlur={handleBlur}
              defaultValue={0}
              onLine
            />
          </div>
        ))}
      </section>
    </>
  );
};
